import { FROZEN_EMPTY_OBJECT } from '@prophecy/utils/constants';
import { useEnabledTranspilersAndLanguages } from 'frontend/core/src/context/enabledTranspilers';
import { useMemo } from 'react';

import { AvailableTranspilers } from '../../Transpiler/config';

const availableTranspilersmap = Object.fromEntries(AvailableTranspilers.map((transpiler) => [transpiler.value, false]));

export function useEnabledTranspilers() {
  const { transpilerToLanguageMap } = useEnabledTranspilersAndLanguages();
  const enabledTranspilers: Record<string, boolean> = useMemo(() => {
    if (transpilerToLanguageMap) {
      let _enabledTranspilers = structuredClone(availableTranspilersmap);
      Object.keys(transpilerToLanguageMap).forEach((transpiler) => {
        _enabledTranspilers[transpiler] = true;
      });
      return _enabledTranspilers;
    }
    return FROZEN_EMPTY_OBJECT as Record<string, boolean>;
  }, [transpilerToLanguageMap]);

  return enabledTranspilers;
}
